import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestExportConsentsGet = {
    path: "/export/consents",
    method: RouteHttpVerb.GET
};
